import { graphql } from 'gatsby'

import { Index } from '../term-and-condition/term-and-condition'

export const Privacy = Index

export default Privacy

export const query = graphql`
    query($regex: String!) {
        allMarkdownRemark(filter: { fileAbsolutePath: { regex: $regex } }) {
            edges {
                node {
                    html
                    headings {
                        value
                        depth
                    }
                }
            }
        }
    }
`
